import React from 'react';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
// HashRouter -> Contrôler de manière plus fine l'URL est mise à jour lorsque l'utilisateur navigue dans l'application avec netlify.

import Home from '../../pages/Home';
import About from '../../pages/About';
import Lodging from '../../pages/Lodging';
import Error from '../../pages/Error';
import Footer from '../Footer';

export default function Root() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/logement/:id" element={<Lodging />} />
        <Route path="/*" element={<Error />} />
      </Routes>
      <Footer />
    </Router>
  );
}
